//@ts-nocheck

export function rolePermissionExists(
  rolePermissions: any,
  permissionName: string,
  permissionPath: string
) {
  let permission = false;

  const permissionDetails = resolve(permissionPath, rolePermissions);
  let userRole = localStorage.getItem("userRole").toUpperCase();
  userRole = userRole === "USER" ? "OPERATOR" : userRole;

  if (userRole === "ALL DATA READONLY") {
    if (permissionName === "READ") {
      permission = true;
    } else if (permissionName === "UPDATE") {
      permission = false;
    }
  } else if (permissionDetails && permissionDetails[userRole]) {
    permission = permissionDetails[userRole][permissionName];
  }

  return permission;
}

function resolve(path: any, obj: any) {
  return path.split(".").reduce((acc: any, part: any) => acc && acc[part], obj);
}

export function formatCurrencyUSD(amount: any) {
  if (amount === null || amount === undefined) return "";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function convertNumeric(amount: string) {
  if (!amount) return 0;
  const result = parseFloat(amount);
  return isNaN(result) ? 0 : result;
}

export function isFundingAmountAcceptable(
  dealFundedAmount,
  currentSyndicator,
  cachedSyndication,
  currentSyndicatorFunding
) {
  let isAllowed = true;
  let exceptCurrentAndDefaultSyndicator = cachedSyndication.filter(
    (syndicator) =>
      syndicator &&
      syndicator.partyId !== currentSyndicator.partyId &&
      !syndicator.defaultSyndicator &&
      (syndicator.funded || syndicator.fundedAmount)
  );
  let exceptCurrentAndDefaultSyndicatorFunding = exceptCurrentAndDefaultSyndicator
    .map((syndicator) => parseFloat(syndicator.funded || syndicator.fundedAmount))
    .reduce(function (a, b) {
      return a + b;
    }, 0);

  let nonDefaultSynFunding =
    exceptCurrentAndDefaultSyndicatorFunding + parseFloat(currentSyndicatorFunding);
  if (nonDefaultSynFunding > dealFundedAmount) {
    isAllowed = false;
  }
  return isAllowed;
}
